import { useRef, useCallback, useEffect } from "react";
import axiosInstance from "../../../axios/axios";
import { END_POINTS } from "../../../shared";
import { useEncryptService } from "../../../shared/hooks";
import { IRequestObject } from "../types";

export const useSearchRequests = () => {
  const { doEncrypt } = useEncryptService();
  const searchSubscriptions = useRef<AbortController[]>([]);

  useEffect(() => {
    return () => {
      cancelAllRequests();
    };
  }, []);

  const cancelAllRequests = useCallback(() => {
    searchSubscriptions.current.forEach((c) => c.abort());
    searchSubscriptions.current = [];
  }, []);

  const removeController = useCallback((controller: AbortController) => {
    searchSubscriptions.current = searchSubscriptions.current.filter(
      (c) => c !== controller
    );
  }, []);

  const search = useCallback(
    async (
      term: string,
      category = "",
      search_type = "",
      page_no = 1,
      content_no = 5
    ) => {
      // Handle category transformation
      let categoryToUse = category;
      if (category === "Controls") {
        categoryToUse = "Parameters";
      } else if (category === "Cloud-Controls") {
        categoryToUse = "Cloud-Parameters";
      }

      const controller = new AbortController();
      searchSubscriptions.current.push(controller);

      const payload: IRequestObject = {
        search: term,
        category: categoryToUse,
        module: categoryToUse === "Resources" || categoryToUse === "Cloud-Parameters" ? "cloud" : categoryToUse === "Assets" || categoryToUse === "Parameters" ? "on_premise" : undefined,
        type: search_type,
        page_no,
        content_no,
      };

      console.log('🚀 Global Search API Payload:', JSON.stringify(payload));

      if (categoryToUse.toLowerCase() === "resources" || categoryToUse.toLowerCase() === "cloud-parameters") {
        console.log(`🚀 [Global Search] Sending Payload for ${categoryToUse}:`, JSON.stringify(payload, null, 2));
      }

      try {
        const res = await axiosInstance.post(
          END_POINTS.GLOBAL_SEARCH,
          //remove encryption when encryption is added in axios
          //remove GLOBAL_SEARCH endpoint from ignoredApi list in axios.ts
          payload,
          { signal: controller.signal }
        );
        removeController(controller);

        if (categoryToUse.toLowerCase() === "resources" || categoryToUse.toLowerCase() === "cloud-parameters") {
          console.log(`🚀 [Global Search] Response for ${categoryToUse}:`, res.data);
        }

        return res.data;
      } catch (error) {
        // Only remove controller if not aborted
        if (
          (error as Error).name !== "AbortError" &&
          (error as Error).name !== "CanceledError"
        ) {
          removeController(controller);
        }
        throw error;
      }
    },
    [doEncrypt, removeController]
  );

  return {
    search,
    cancelAllRequests,
    currentRequests: searchSubscriptions,
  };
};
